<mat-card data-cy="notification-card" class="tw-mb-2 notification-card" [@animation]>
  <div class="tw-flex" [ngClass]="notification.navigationRoute ? 'tw-cursor-pointer' : ''" (click)="notification.navigationRoute ? navigateTo() : ''">
    <div class="tw-grow-0 tw-mr-4 tw-text-center">
      <mat-icon [class]="notification.color + ' icon tw-rounded-full tw-leading-relaxed'">
        {{ notification.icon }}
      </mat-icon>
    </div>
    <div class="tw-flex-grow">
      <div class="tw-flex">
        <div class="tw-flex-grow tw-cursor-pointer" (click)="navigateTo()">
          <div class="tw-font-bold tw-text-base">
            {{ notification.heading ? notification.heading : notification.type | titlecase }}
          </div>
          <div class="tw-text-gray-500">
            {{ notification.title }}
          </div>
        </div>
        <div
          (click)="handleDismiss()"
          *ngIf="notification.dismissible && notification.type !== 'callQueue' && !notification.hideDismissButton"
          class="tw-cursor-pointer tw-grow-0"
          data-cy="close-notification-btn">
          <mat-icon>close</mat-icon>
        </div>
      </div>
      <div class="tw-flex tw-pt-1 tw-flex-row">
        <div
          class="tw-flex-auto"
          *ngIf="notification.content"
          [innerHtml]="notification.content">
        </div>
      </div>
      <div>
        <div class="tw-text-right tw-mt-2" *ngIf="notification.actions">
          <div *ngIf="notification.actions.length < 3; else actionsMenu">
            <button
              color="primary"
              class="tw-ml-2"
              mat-button
              *ngFor="let action of notification.actions"
              (click)="action.function(); handleDismiss();">
              {{ action.text }}
            </button>
          </div>
          <ng-template #actionsMenu>
            <button
              mat-button
              color="primary"
              [matMenuTriggerFor]="menu">
              Actions <mat-icon style="transform:translate(0px, -2px);">arrow_drop_down</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                *ngFor="let action of notification.actions"
                (click)="action.function(); handleDismiss();">
                {{ action.text }}
              </button>
            </mat-menu>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</mat-card>
